($ => {
  const lightboxOpen = $(".js-steps-lightbox");
  const lightbox = $(".lightbox");
  const lightboxClose = $(".js-lightbox-close");
  let halfHeight = $(window).height() / 2;
  let halfWidth = $(window).width() / 2;
  const setPosition = () => {
    lightbox.each(function() {
      let self = $(this);

      self.offset({
        top: $(document).scrollTop() + halfHeight,
        left: halfWidth
      });
    });
  };

  const openLightbox = (event, self) => {
    self.prev(".lightbox").addClass("open");
    $("body").addClass("scrollLock");
    $("main").addClass("z-index-100");
    event.stopPropagation();
  };

  const closeLightbox = self => {
    lightbox.each(function() {
      let self = $(this);

      self.removeClass("open");
    });
    $("main").removeClass("z-index-100");
    $("body").removeClass("scrollLock");
  };

  $(document).ready(() => {
    setPosition();
    $(window).on("scroll", function() {
      setPosition();
    });
    lightboxOpen.each(function() {
      let self = $(this);

      self.on("click", e => openLightbox(event, self));
    });

    lightboxClose.on("click", function() {
      closeLightbox();
    });
  });
})(jQuery);
